import React from 'react';
interface Column {
  key: string;
  header: string;
  sortable?: boolean;
}
interface Action {
  label: string;
  onClick: (id: string) => void;
  color: string;
  icon?: React.ReactNode;
}
interface JobsTableProps {
  columns: Column[];
  data: any[];
  actions?: Action[];
  filters?: boolean;
}
export const JobsTable = ({
  columns,
  data,
  actions,
  filters = false
}: JobsTableProps) => {
  return;
};